export default __webpack_public_path__ + "static/g-ross-73e6b5c5832d64d6a10a58dac7baec7e.jpg";